<template>
    <div v-if="cargando" class="fixed w-full flex justify-center">
        <img class="w-44" src="https://thebowlcut.com/cdn/shop/t/41/assets/loading.gif?v=157493769327766696621701744369" alt="">
    </div>
    <div class="shadow-md p-3 w-full">
      <div class="flex gap-2 items-center">
        <RouterLink to="/admin/productos" class="btn border">Volver</RouterLink>
        <button @click="abrirModal()" class="btn btn-sm btn-outline-primary border">Nueva Marca</button>
        <p class="ml-3">Catalogo: </p>
        <div class="flex gap-2">
          <div class="flex items-center gap-1">
            <p>Logo</p>
            <input type="checkbox" v-model="logo">
          </div>
          <p>|</p>
          <div class="flex items-center gap-1">
            <p>Imagenes</p>
            <input type="checkbox" v-model="img">
          </div>
          <p>|</p>
          <div class="flex items-center gap-1">
            <p>Precios</p>
            <input type="checkbox" v-model="precio">
          </div>
        </div>
      </div>
      <div class="mt-1">
        <table class="table table-bordered text-left">
          <thead>
            <tr>
              <td>Marca</td>
              <td>Categoria</td>
              <td>Subcategoria</td>
              <td>Orden Categoria</td>
              <td>Orden Subcategoria</td>
              <td>Catalogo</td>
            </tr>
          </thead>
          <tbody v-for="(marca, key) in categoriasOrdenadas" :key="key">
            <tr>
              <td>{{ marca.marca }}</td>
              <td><button @click="abrirModal(marca.idmarca)" class="btn btn-sm btn-outline-primary border">Nueva Categoria</button></td>
              <td></td>
              <td><button class="btn btn-sm btn-danger" :disabled="cargando" @click="generarExcel(1, marca.idmarca)">Generar Excel</button><button class="btn btn-sm btn-danger" :disabled="cargando" @click="generarCatalogo(1, marca.idmarca)">Generar pdf</button></td>
              <td></td>
              <td></td>
            </tr>
            <template v-for="(cat, ind) in marca.categorias" :key="ind">
              <tr>
                <td class="flex items-center justify-end"><button @click="borrarCat(cat.idcat, cat.categoria)"><img class="w-6" src="../assets/icons/bin.png" alt=""></button><button @click="modalEditar(cat.idcat, cat.categoria)"><img class="w-6" src="../assets/icons/pencil.png" alt=""></button></td>
                <td v-if="!cat.subCategorias.length" class="hover:text-blue-500 cursor-pointer" @click="editarArticulos(marca.idmarca, cat.idcat)" title="editar orden articulos">{{ cat.categoria }}</td>
                <td v-else>{{ cat.categoria }}</td>
                <td><button @click="abrirModal(marca.idmarca, cat.idcat)" class="btn btn-sm btn-outline-primary border">Nueva SubCategoria</button></td>
                <td><input :disabled="cargando" min="0" @change="ordenCats(key, cat.idcat, cat.orden)" class="text-right" type="number" v-model="cat.orden"></td>
                <td><button class="btn btn-sm btn-danger" :disabled="cargando" @click="generarExcel(2, cat.idcat)">Generar Excel</button><button class="btn btn-sm btn-danger" @click="generarCatalogo(2, cat.idcat)" :disabled="cargando">Generar pdf</button></td>
                <td></td>
              </tr>
              <tr v-for="sub in cat.subCategorias" :key="sub">
                  <td></td>
                  <td class="flex items-center justify-end"><button @click="borrarCat(sub.idsubcat, sub.subcategoria)"><img class="w-6" src="../assets/icons/bin.png" alt=""></button><button @click="modalEditar(sub.idsubcat, sub.subcategoria)"><img class="w-6" src="../assets/icons/pencil.png" alt=""></button></td>
                  <td class="hover:text-blue-500 cursor-pointer" @click="editarArticulos(marca.idmarca, cat.idcat, sub.idsubcat)" title="editar orden articulos">{{ sub.subcategoria }}</td>
                  <td></td>
                  <td><input :disabled="cargando" min="0" @change="ordenSub(key, ind, sub.idsubcat, sub.orden)" class="text-right" type="number" v-model="sub.orden"></td>
                  <td><button class="btn btn-sm btn-danger" :disabled="cargando" @click="generarExcel(3, sub.idsubcat)">Generar Excel</button><button class="btn btn-sm btn-danger" @click="generarCatalogo(3, sub.idsubcat)" :disabled="cargando">Generar pdf</button></td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal" id="modalTipo">
        <div class="modal-dialog">
          <div class="modal-content">
          
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">{{ modalTitle }}</h4>
            </div>
            
            <!-- Modal body -->
            <div class="modal-body">
                <input class="form-control mt-2" type="text" placeholder="Nombre" v-model="nombreCat">
            </div>
            
            <!-- Modal footer -->
            <div class="modal-footer">
              <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
              <button v-if="!idCat" class="btn btn-success" :disabled="cargando" @click="nuevoItem()">Guardar</button>
              <button v-else class="btn btn-success" :disabled="cargando" @click="editarItem()">Guardar</button>
            </div>
            
          </div>
        </div>
      </div>

      <div class="modal" id="modalArticulos">
        <div class="modal-dialog">
          <div class="modal-content">
          
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">Editar orden articulos</h4>
            </div>
            
            <!-- Modal body -->
            <div class="modal-body">
              <div v-for="(art, key) in articulosEditar" :key="key" class="flex gap-2 justify-between items-center mt-2">
                <p class="text-sm">{{ art.codigo }}</p>
                <p class="text-sm">{{ art.nombre }}</p>
                <input @change="cambioArts(key, art.orden)" :disabled="cargando" class="form-control w-32" type="number" placeholder="Orden" v-model="art.orden">
              </div>
            </div>
            
            <!-- Modal footer -->
            <div class="modal-footer">
              <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
            </div>
            
          </div>
        </div>
      </div>
  </template>
  
  <script>
  import pedidosService from '@/services/pedidos.service';
  export default {
    data() {
      return {
        categorias: [],
        categoriasOrdenadas: [],
        cargando: false,
        modalTitle: '',
        tipoCat: '',
        nombreCat: '',
        padreCat: '',
        padreMarca: '',
        idCat: '',
        articulosEditar: [],
        img: true,
        logo: true,
        precio: true,
      };
    },
    mounted() {
      this.getAllCategorias()
    },
    methods: {
      generarCatalogo(num, id) {
        this.cargando = true
        pedidosService.generarCatalogo(this.logo ? 1 : 0, this.img ? 1 : 0, this.precio ? 1 : 0, num == 1 ? id : null, num == 2 ? id : null, num == 3 ? id : null)
          .then(res => {
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
            const year = today.getFullYear();
            link.setAttribute('download', 'catalogo-'+`${day}-${month}-${year}`+'.pdf'); // Set the filename for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((er) => {
            console.log(er)
          })
          .finally(() => {
            this.cargando = false
          })
      },
      generarExcel(num, id) {
        this.cargando = true
        pedidosService.generarExcel(this.logo ? 1 : 0, this.img ? 1 : 0, this.precio ? 1 : 0, num == 1 ? id : null, num == 2 ? id : null, num == 3 ? id : null)
          .then(res => {
            const blob = new Blob([res.data], { type: 'application/xlsx' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
            const year = today.getFullYear();
            link.setAttribute('download', 'catalogo-'+`${day}-${month}-${year}`+'.xlsx'); // Set the filename for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((er) => {
            console.log(er)
          })
          .finally(() => {
            this.cargando = false
          })
      },
      cambioArts(index, orden) {
        this.cargando = true
        this.articulosEditar.forEach(x => {
          if (x.orden <= 0) {
            x.orden = 1
          }
          if (x.orden == orden) {
            x.orden++
          }
        })
        var cat = this.articulosEditar[index]

        cat.orden = orden
        this.articulosEditar = this.articulosEditar.sort((a, b) => {
          if (a.orden > b.orden) {
            return 1
          } else if (b.orden > a.orden) {
            return -1
          }
          
          if (a.idart > b.idart) {
            return -1
          } else if (b.idart > a.idart) {
            return 1
          }
        })
        for (var i = 0; i < this.articulosEditar.length; i++) {
          this.articulosEditar[i].orden = i + 1
        }
        pedidosService.editarOrdenArticulos(this.articulosEditar)
          .then(() => {
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
          })
          .catch((err) => {
            console.log(err)
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          })
          .finally(() => {
            this.cargando = false
          })
      },
      editarArticulos(idmarca, idcat, idsub) {
        this.articulosEditar = []
        this.cargando = true
        pedidosService.getAllProductosSubcat(idmarca, idcat, idsub)
          .then((res) => {
            this.articulosEditar = res.data.map(x => {
              var art = {
                idart: x.IDART_IO,
                codigo: x.CODIGO_ART,
                nombre: x.DESCRIP_ART,
                orden: x.ORDEN_IO
              }
              return art
            })
            window.$('#modalArticulos').modal('show')
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() => {
            this.cargando = false
          })
      },
      modalEditar(idcat, categoria) {
        this.idCat = idcat
        this.nombreCat = categoria
        this.modalTitle = 'Modificar ' + this.nombreCat
        window.$('#modalTipo').modal('show')
      },
      borrarCat(idcat, categoria) {
        const userConfirmed = confirm("Desea borrar " + categoria + "? si tiene items asociados puede afectar a los mismos")
        if (userConfirmed) {
          console.log(idcat)
          pedidosService.borrarCategoria(idcat)
            .then(() => {
              this.getAllCategorias()
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
            })
            .catch((err) => {
              console.log(err)
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
        }
      },
      editarItem() {
        if (this.idCat && this.nombreCat) {
          pedidosService.editarCategoria(this.idCat, encodeURIComponent(this.nombreCat))
            .then(() => {
              this.getAllCategorias()
              this.nombreCat = ''
              this.padreCat = ''
              this.padreMarca = ''
              this.idCat = ''
              this.tipoCat = ''
              this.modalTitle = ''
              window.$('#modalTipo').modal('hide')
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
            })
            .catch((err) => {
              console.log(err)
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
        }
      },
      nuevoItem() {
        if (this.nombreCat && this.padreMarca) {
          var itm = {
            nombre: this.nombreCat,
            idPadre: this.padreCat ? this.padreCat : null,
            orden: this.padreMarca,
            activo: 1,
            destacada: 0,
            peso: 0
          }
          pedidosService.nuevaCategoria(itm)
            .then(() => {
              this.getAllCategorias()
              this.nombreCat = ''
              this.padreCat = ''
              this.padreMarca = ''
              this.tipoCat = ''
              this.modalTitle = ''
              window.$('#modalTipo').modal('hide')
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
            })
            .catch(err => {
              console.log(err)
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
        } else if (this.nombreCat && !this.padreMarca) {
          pedidosService.nuevaMarca(this.nombreCat)
            .then(() => {
              this.getAllCategorias()
              this.nombreCat = ''
              this.tipoCat = ''
              this.modalTitle = ''
              window.$('#modalTipo').modal('hide')
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
            })
            .catch(err => {
              console.log(err)
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
        }
      },
      abrirModal(idmarca, idcat) {
        this.nombreCat = ''
        this.idCat = ''
        this.padreCat = ''
        this.padreMarca = ''
        if (!idmarca) {
          var tipo = 'Marca'
        }
        else if (idcat) {
          tipo = 'SubCategoria'
          this.padreCat = idcat
          this.padreMarca = idmarca

        } else {
          this.padreMarca = idmarca
          this.padreCat = null
          tipo = 'Categoria'
        }
        this.tipoCat = tipo
        this.modalTitle = 'Añadir nueva ' + this.tipoCat
        window.$('#modalTipo').modal('show')
      },
      getAllCategorias() {
        pedidosService.getAllCategorias()
          .then((res) => {
            this.categorias = res.data;
            this.formatCategorias(this.categorias)
          })
          .catch((res) => {
            console.log(res);
          });
      },
      formatCategorias(cats) {
        var marcas = [];
        cats.forEach((x) => {
          if (!marcas.includes(x.Marca)) {
            marcas.push(x.Marca);
          }
        });
        marcas = marcas.map((x) => {
          return { marca: x, categorias: [] };
        });
        marcas.forEach((x) => {
          x.categorias = [];
          var catsMarca = cats.filter((a) => a.Marca == x.marca);
          catsMarca.forEach((c) => {
            if (!x.categorias.includes(c.Categoria)) {
              x.categorias.push(c.Categoria);
            }
          });
          x.idmarca = catsMarca[0].IDMARCA_IO;

          x.categorias = x.categorias.map((c) => {
            return { categoria: c, subCategorias: [] };
          });

          x.categorias.forEach((c) => {
            var id = cats.filter(
              (a) => a.Marca == x.marca && a.Categoria == c.categoria
            );
            c.idcat = id[0].IDCATEGORIA_IO;
            c.orden = id[0].OrdenCategoria
            var temp = cats.filter(
              (a) =>
                a.Marca == x.marca && a.Categoria == c.categoria && a.Subcategoria
            );
            if (temp && temp.length > 0 && temp[0]) {
              c.subCategorias = temp.map((s) => {
                return {
                  subcategoria: s.Subcategoria,
                  idsubcat: s.IDSUBCATEGORIA_IO,
                  orden: s.OrdenSubcategoria
                };
              });
            } else {
              x.subCategorias = [];
            }
          });
        });

        this.categoriasOrdenadas = marcas;
      },
      async ordenCats(m, id, orden) {
        if (orden != null && orden != '' && orden >= 0) {
          this.cargando = true
          var cat = this.categoriasOrdenadas[m].categorias.find(x => x.idcat == id)
          this.categoriasOrdenadas[m].categorias = this.categoriasOrdenadas[m].categorias.sort((a, b) => {
            if (a.orden > b.orden) {
              return 1
            } else if (b.orden > a.orden) {
              return -1
            }

            if (a.orden == cat.orden) {
              return -1
            } else if (b.orden == cat.orden) {
              return 1
            }

            if (a.idcat > b.idcat) {
              return 1
            } else if (b.idcat > a.idcat) {
              return -1
            }
          })
          for (var i = 0; i < this.categoriasOrdenadas[m].categorias.length; i++) {
            this.categoriasOrdenadas[m].categorias[i].orden = i + 1
          }
          await pedidosService.cambiarOrdenCat(this.categoriasOrdenadas[m].categorias)
            .then(() => {
              this.categoriasOrdenadas[m].categorias = this.categoriasOrdenadas[m].categorias.sort((x, y) => x.orden - y.orden)
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
              this.cargando = false
            })
            .catch(err => {
              console.log(err)
              this.cargando = false
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
        }
      },
      async ordenSub(m, c, id, orden) {
        if (orden != null && orden != '' && orden >= 0) {
          this.cargando = true
          var subcat = this.categoriasOrdenadas[m].categorias[c].subCategorias.find(x => x.idsubcat == id)
          this.categoriasOrdenadas[m].categorias[c].subCategorias = this.categoriasOrdenadas[m].categorias[c].subCategorias.sort((a, b) => {
            if (a.orden > b.orden) {
              return 1
            } else if (b.orden > a.orden) {
              return -1
            }

            if (a.orden == subcat.orden) {
              return -1
            } else if (b.orden == subcat.orden) {
              return 1
            }

            if (a.idsubcat > b.idsubcat) {
              return 1
            } else if (b.idsubcat > a.idsubcat) {
              return -1
            }
          })
          for (var i = 0; i < this.categoriasOrdenadas[m].categorias[c].subCategorias.length; i++) {
            this.categoriasOrdenadas[m].categorias[c].subCategorias[i].orden = i + 1
          }
          await pedidosService.cambiarOrdenSubcat(this.categoriasOrdenadas[m].categorias[c].subCategorias)
            .then(() => {
              this.categoriasOrdenadas[m].categorias[c].subCategorias = this.categoriasOrdenadas[m].categorias[c].subCategorias.sort((x, y) => x.orden - y.orden)
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
              this.cargando = false
            })
            .catch(err => {
              console.log(err)
              this.cargando = false
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
        }
        
      }
    },
    computed: {
    },
  };
  </script>

